//
import parse from 'html-react-parser';
import { PropTypes } from 'prop-types';
import queryString from 'query-string';
import React from 'react';

import { FormattedMessage, injectIntl, } from 'react-intl';

import htmlParserTransform from '../../helpers/htmlParserTransform';

import BodyStyle from '../common/BodyStyle';
import Redirect from '../common/Redirect';
import NewsletterList from '../common/newsletter/NewsletterList';
import Notification from '../common/notification/Notification';
import LegacyTheme from '../common/personalization/LegacyTheme';
import Personalization from '../common/personalization/Personalization';
import LoadingSpinner from '../common/spinner/LoadingSpinner';

import MsgAPI from '../../api/msg/MsgAPI';
import PublicCustomAPI from '../../api/publiccustom/PublicCustomAPI';

import MapperService from '../../services/MapperService';

import deepGetSet from '../../api/deepGetSet';
import FrontendException from '../../models/FrontendException';

import withResizeObserver from '../../hoc/withResizeObserver';

const escapeRegExp = (string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
};

class AutoprofileMsg extends React.Component {
  constructor() {
    super();
    //
    this.mounted = false;
    this.notificationRef = React.createRef();
    //
    this.actionSettings = {};
    this.textSettings = {};
    //
    this.msgSettings = {
      Content: '',
      RedirectURL: ''
    };
    this.listGUID = '';
    this.clientIP = '';
    this.subscriberData = {};
    this.newsletters = [];
    this.showNewsletterList = false;
    this.emailForPreview = 'test@test.com';
    this.styles = ['default', 'blue', 'dark', 'gray', 'green'];
    this.customClass = ''; //  Default
    this.flowConfig = {
      UseCustomPages: false,
      CustomPages: {}
    };
    //
    this.state = {
      loading: false,
      showMainContent: false
    };
  }

  componentDidMount() {
    this.mounted = true;
    const params = this.props.match.params;

    if (!this.isUserParamsValid()) {
      //  do not use setState directly in componentDidMount
      this.handleError("Load.Msg.ErrorUserParams");
    } else {
      //
      const params = this.props.match.params;
      const actionCode = this.getActionCode(params.idMsg);
      const qsValues = queryString.parse(this.props.location.search);
      //
      Promise.all([
        this.getPublicCustomAction(params.idList, actionCode),
        this.getPublicCustomText(params.idList, actionCode),
        this.getPublicCustomSettings(params.idList),
        this.getListGUID(params.idList),
        this.getClientIP(),
        this.getSubscriberData(params.idList, params.idUser, params.hash),
        this.getNewsletterList(),
        this.getCustomFlowConfig(qsValues.cfc)
      ]).then(() => {
        if (this.flowConfig.UseCustomPages) {
          this.msgSettings.Content = this.flowConfig.CustomPages[actionCode].Text;
        } else if (deepGetSet(this.textSettings, 'Text')) {
          this.msgSettings.Content = this.textSettings.Text;
        } else {
          const msgLabel = MapperService.getPostEventDefaultMessage(actionCode);
          this.msgSettings.Content = this.props.intl.formatMessage({
            id: msgLabel,
            defaultMessage: msgLabel
          });
        }

        //
        if (this.flowConfig.UseCustomPages) {
          const { IdLandingPage, CustomUrl } = this.flowConfig.CustomPages[actionCode];

          this.actionSettings.IdLandingPage = IdLandingPage;
          this.actionSettings.CustomUrl = CustomUrl;
        }

        if (this.isTrue(params.preview)) {
          this.msgSettings.RedirectURL = '';
          //
          this.msgSettings.Content = this.replacePlaceholders(this.msgSettings.Content, {
            email: this.emailForPreview,
            IPaddress: this.clientIP
          }, false);
        } else {
          if (this.actionSettings.IdLandingPage) {
            this.msgSettings.RedirectURL = '/frontend/LandingPage.aspx?idList=' +
              encodeURIComponent(params.idList) + '&idLP=' + encodeURIComponent(this.actionSettings.IdLandingPage) +
              '&guid=' + encodeURIComponent(this.listGUID);
            this.msgSettings.Content = undefined;
          } else if (this.actionSettings.CustomUrl) {
            this.msgSettings.RedirectURL = this.actionSettings.CustomUrl;
            //
            this.msgSettings.RedirectURL = this.replacePlaceholders(this.msgSettings.RedirectURL, this.subscriberData, true);
            this.msgSettings.Content = undefined;
          } else {
            this.msgSettings.Content = this.replacePlaceholders(this.msgSettings.Content, this.subscriberData, false);
          }
        }
        //
        if (this.mounted) {
          this.setState({
            showMainContent: true
          });
        }
      }).catch((error) => {
        this.handleError(error, "default", true);
      })
        .finally(this.stopLoader);
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  isTrue(paramValue) {
    return ((paramValue == "true") || (paramValue == "1") || (paramValue == "on"));
  }

  isString(param) {
    return (typeof param === "string") || (param instanceof String);
  }

  /**
   * Verifica parametri idList, idMsg, email
   * se vuoti/nulli ritorna false
   */
  isUserParamsValid() {
    const params = this.props.match.params;
    const preview = this.isTrue(params.preview);
    const idUser = parseInt(params.idUser, 10);
    //
    //  combinazioni accettate:
    //  preview:1 - idUser:empty - hash:empty
    //  preview:0 - idUser:0 - hash:_
    //  preview:0 - idUser:valorizzato - hash:valorizzato
    return Boolean(params.idList && params.idMsg && ((!preview && idUser && params.hash) || (!preview && !idUser && params.hash == '_') || preview));
  }

  handleError = (error, source = "default", fatal = false) => {
    console.error("### AutoprofileMsg handleError", error);
    let errorLabel = "Load.Common.Error";
    if (error instanceof FrontendException) {
      errorLabel = error.label;
    } else if (this.isString(error)) {
      errorLabel = error;
    }
    //
    this.notificationRef.current.addError(this.props.intl.formatMessage({
      id: errorLabel,
      defaultMessage: errorLabel
    }), source, false, !fatal);
  }

  getPublicCustomAction(idList, actionCode) {
    return PublicCustomAPI.getAction(idList, actionCode).then((actionSettings) => {
      this.actionSettings = actionSettings;
    });
  }

  getPublicCustomText(idList, actionCode) {
    return PublicCustomAPI.getText(idList, actionCode).then((textSettings) => {
      this.textSettings = textSettings;
    });
  }

  getPublicCustomSettings(idList) {
    return PublicCustomAPI.getSettings(idList).then((listSettings) => {
      this.showNewsletterList = listSettings.ShowPublicEmailMessagesProfilation;
    });
  }

  getListGUID(idList) {
    return PublicCustomAPI.getListGUID(idList).then((listGUID) => {
      this.listGUID = listGUID;
    });
  }

  getClientIP() {
    return PublicCustomAPI.getClientIP().then((clientIP) => {
      this.clientIP = clientIP;
    });
  }

  getCustomFlowConfig(idCustomFlowConfig) {
    return idCustomFlowConfig
      ? PublicCustomAPI.getCustomFlowConfig(idCustomFlowConfig).then(({
        UseCustomPages,
        CustomPages,
        CustomMsgs
      }) => {
        this.flowConfig = {
          UseCustomPages,
          CustomPages: CustomPages.reduce((acc, { Code, IdLandingPage, CustomUrl }) => ({
            ...acc,
            [Code]: {
              IdLandingPage,
              CustomUrl,
              Code,
              Text: (IdLandingPage === 0 && CustomUrl.length === 0)
                ? CustomMsgs.find(cm => cm.Code === Code).Text
                : ''
            }
          }), {})

        };
      })
      : Promise.resolve(true)
      ;
  }

  getSubscriberData(idList, idUser, hash) {
    if (!parseInt(idUser, 10)) {
      idUser = 0;
    }
    if (!hash || hash == '_') {
      hash = '';
    }

    return MsgAPI.getSubscriberData(idList, idUser, hash).then((subscriberData) => {
      this.subscriberData = subscriberData;
      //
      if (!idUser) {
        this.subscriberData.email = this.emailForPreview;
      }
    });
  }

  replacePlaceholders(content, map, uriEncode) {
    Object.keys(map).forEach((key) => {
      if (uriEncode) {
        content = content.replaceAll('[' + key + ']', encodeURIComponent(map[key]));
      } else {
        content = content.replaceAll('[' + key + ']', map[key]);
      }
    });
    return content;
  }

  getNewsletterList() {
    const params = this.props.match.params;
    return MsgAPI.getNewsletterList(params.idList).then((newsletters) => {
      this.newsletters = newsletters.MessagesItems;
    });
  }

  getActionCode(idMsg) {
    let result = "";
    switch (parseInt(idMsg, 10)) {
      case 1:
        result = "PostProfiling_ChangesSaved";
        break;
      case 2:
        result = "PostProfiling_UpdateFailed";
        break;

      case 3:
      case 4:
        result = "PostProfiling_FormNotActive";
        break;

      case 5:
        result = "PostProfiling_FormAlreadyFilledOut";
        break;

      case 6:
        result = "PostProfiling_PrivateFormAccessEmailSent";
        break;

      case 7:
        result = "PostProfiling_Unsubscribed";
        break;

      case 8:
        result = "PostProfiling_RecipientDoesNotExist";
        break;

      case 9:
        result = "PostProfiling_ConfirmSubscription";
        break;
    }
    return result;
  }

  startLoader = () => {
    if (this.mounted) {
      this.setState({
        loading: true
      });
    }
  }

  stopLoader = () => {
    if (this.mounted) {
      this.setState({
        loading: false
      });
    }
  }

  render() {
    const isEmbedded = this.isTrue(this.props.match.params.emb);
    const applyCustomCSS = (this.props.match.params.style == 'custom');
    //
    if (this.styles.indexOf(this.props.match.params.style) != -1) {
      this.customClass = this.props.match.params.style;
    }
    //
    return (
      <div>
        <BodyStyle customClass={this.customClass} />
        {this.customClass &&
          <LegacyTheme style={this.customClass} mode="autoprofile" />
        }
        <Notification ref={this.notificationRef} />
        {this.state.loading && <LoadingSpinner />}

        {this.state.showMainContent && isEmbedded &&
          <React.Fragment>
            <BodyStyle customClass="pref-center_body-form-embeddato" />

            {this.msgSettings.Content &&
              <h3 className="frontend-m-top-sm">{parse(this.msgSettings.Content, { replace: htmlParserTransform })}</h3>
            }

            {this.msgSettings.RedirectURL &&
              <Redirect to={this.msgSettings.RedirectURL} />
            }
          </React.Fragment>
        }

        {this.state.showMainContent && !isEmbedded &&
          <React.Fragment>
            {this.msgSettings.RedirectURL &&
              <Redirect to={this.msgSettings.RedirectURL} />
            }

            {this.msgSettings.Content &&
              <div className="frontend-wrapper">
                <Personalization idList={this.props.match.params.idList} showLogo applyCustomCSS={applyCustomCSS} />
                <div className="frontend-box frontend-row">
                  <div className="frontend-row frontend-text-casistica">{parse(this.msgSettings.Content, { replace: htmlParserTransform })}</div>
                </div>

                {this.newsletters.length > 0 && this.showNewsletterList && !this.msgSettings.RedirectURL &&
                  <div className="box-latest-newsletter frontend-row">
                    <h4 className="frontend-title-paragraph frontend-row-x-sm"><FormattedMessage id="Load.Msg.LatestPublishedNewsletters" defaultMessage="Load.Msg.LatestPublishedNewsletters" /></h4>
                    <NewsletterList list={this.newsletters} />
                  </div>
                }
              </div>
            }
          </React.Fragment>
        }
      </div>
    );
  }
}

AutoprofileMsg.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      preview: PropTypes.string.isRequired,
      idList: PropTypes.string,
      idMsg: PropTypes.string,
      style: PropTypes.string,
      idUser: PropTypes.string,
      hash: PropTypes.string,
      emb: PropTypes.string
    })
  }),

  location: PropTypes.object
};

export default withResizeObserver(injectIntl(AutoprofileMsg), 'AutoprofileMsg');